import { Injectable } from '@angular/core';
import {
  HttpContextToken,
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { catchError, Observable, throwError } from "rxjs";
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";
import { TranslateService } from "@ngx-translate/core";
import { ConnectionStatusService } from '../services/connection-status.service';

export const SKIP_ERROR_TOAST = new HttpContextToken<boolean>(() => false);
export const SKIP_LOADER_HIDE = new HttpContextToken<boolean>(() => false);

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private _spinner: NgxSpinnerService,
    private _toastr: ToastrService,
    private _translate: TranslateService,
    private connectionStatusService: ConnectionStatusService
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request)
      .pipe(
        catchError((error: HttpErrorResponse) => {
          if (!request.context.get(SKIP_LOADER_HIDE)) {
            void this._spinner.hide();
          }
          if (!request.context.get(SKIP_ERROR_TOAST) && !this.connectionStatusService.isSyncing()) {
            const errorCode = error.error.code || "DEFAULT";
            const message = errorCode === 'TASK_SEND_CLONE_TASK_MISSING' && error.error.message
              ? error.error.message
              : this._translate.instant("ERRORS." + errorCode);
            this._toastr.error(message);
          }
          return throwError(() => error);
        })
      )
  }
}





